export const stakingRoutes = [
  {
    path: "/staking",
    name: "Staking",
    component: () => import("@/views/Staking/Main.vue"),
    meta: {
      topLevel: true,
      parent: "Staking",
      menu: true,
      showDemoVersion: true,
    },
  },
  {
    path: "/staking/create",
    name: "StakingCreate",
    component: () => import("@/views/Staking/Create.vue"),
    meta: {
      parent: "Staking",
      noBack: false,
    },
  },
  {
    path: "/staking/choose-coin",
    name: "StakingChooseCoin",
    component: () => import("@/views/Staking/ChooseCoin.vue"),
    meta: { showDemoVersion: true },
  },
  {
    path: "/staking/item/:id",
    name: "StakingItem",
    component: () => import("@/views/Staking/Item/Main.vue"),
    meta: {
      parent: "Staking",
      noBack: false,
    },
  },
  {
    path: "/staking/item/:id/topup",
    name: "StakingTopUp",
    component: () => import("@/views/Staking/Item/TopUp.vue"),
  },
  {
    path: "/staking/item/:id/withdraw",
    name: "StakingWithdraw",
    component: () => import("@/views/Staking/Item/Withdraw.vue"),
  },
  {
    path: "/staking/item/:id/close",
    name: "StakingClose",
    component: () => import("@/views/Staking/Item/ConfirmClose.vue"),
  },
  {
    path: "/staking/success",
    name: "StakingSuccess",
    component: () => import("@/views/Staking/Item/Success.vue"),
    meta: {
      noBack: true,
    },
  },
  {
    path: "/staking/history",
    name: "StakingHistory",
    component: () => import("@/views/Staking/History.vue"),
    meta: { parent: "StakingHistory", noBack: false },
  },
  {
    path: "/staking/item/:id/history",
    name: "StakingItemHistory",
    component: () => import("@/views/Staking/Item/History.vue"),
  },
];
